import { Component, OnInit } from '@angular/core';
import { filter, Observable } from 'rxjs';
import { Action, View } from '../../../../../shared/store/view/types';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../../shared/service/modal.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalContentComponent } from '../../../../../shared/components/modal-content/modal-content.component';
import { ActionButton } from '../../../../../shared/components/modal-content/action-button';
import { SourceEnum } from '../../../../../shared/store/typeahead/types';
import {
  InsuranceClaimModel,
  InsuranceClaimStatusFlow,
} from '../../../../../shared/store/insurance-claim/types';
import { InsuranceClaimService } from '../../../../../shared/store/insurance-claim/insurance-claim.service';
import { ConfigurationService } from '../../../../../shared/service/configuration.service';
import { ModalComponentKey } from 'src/app/shared/service/modal-component';

@UntilDestroy()
@Component({
  selector: 'app-custom-actions-flow-insurance-claim',
  standalone: false,
  templateUrl: './custom-actions-flow-insurance-claim.component.html',
  styleUrl: './custom-actions-flow-insurance-claim.component.scss',
})
export class CustomActionsFlowInsuranceClaimComponent implements OnInit {
  view$: Observable<View>;
  insuranceClaim$: Observable<InsuranceClaimModel>;
  insuranceClaimStatusFlows$: Observable<InsuranceClaimStatusFlow[]>;
  customActions$: Observable<Action[]>;
  insuranceClaimId: number;

  constructor(
    private readonly insuranceClaimService: InsuranceClaimService,
    private readonly viewService: ViewService,
    private readonly subHeaderService: SubHeaderService,
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
    private readonly configurationService: ConfigurationService,
  ) {}

  ngOnInit(): void {
    this.view$ = this.viewService.getViews.value$;
    this.insuranceClaim$ = this.insuranceClaimService.getByUniqueId.value$;
    this.insuranceClaimStatusFlows$ =
      this.insuranceClaimService.getStatusFlow.value$;
    this.customActions$ = this.insuranceClaimService.getStatusActions.value$;

    this.insuranceClaim$
      .pipe(
        filter((x) => !!x),
        untilDestroyed(this),
      )
      .subscribe((insuranceClaim) => {
        this.insuranceClaimService.getStatusFlow.call(
          insuranceClaim.claimStatus,
        );
        this.insuranceClaimService.getStatusActions.call(
          insuranceClaim.claimStatus,
        );
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(
        filter((x) => !!x),
        untilDestroyed(this),
      )
      .subscribe((x) => {
        if (x == 'backToOpen') this.openClaim();
        if (x == 'requestValidation' || x == 'backToValidation')
          this.requestValidation();
        if (x == 'validate' || x == 'backToTransmitted') this.validate();
        if (x == 'openDossier' || x == 'backToDossierOpened')
          this.openDossierToTransmitter();
        if (x == 'close') this.close();
        if (x == 'reopen') this.reopen();

        if (x == 'reject') this.reject();

        this.subHeaderService.setTriggerAction('');
      });
  }

  triggerStatusFlow(actionName: string, insuranceClaimId: number) {
    this.insuranceClaimId = insuranceClaimId;
    this.subHeaderService.setTriggerAction(actionName);
  }

  private openClaim() {
    this.insuranceClaimService.openClaim.call(this.insuranceClaimId);
  }

  private requestValidation() {
    this.insuranceClaimService.requestValidation.call(this.insuranceClaimId);
  }

  private validate() {
    this.insuranceClaimService.validate.call(this.insuranceClaimId);
  }

  private openDossierToTransmitter() {
    this.insuranceClaimService.openDossierToTransmitter.call(
      this.insuranceClaimId,
    );
  }

  private close() {
    this.insuranceClaimService.close.call(this.insuranceClaimId);
  }

  private reopen() {
    this.insuranceClaimService.reopen.call(this.insuranceClaimId);
  }

  private reject() {
    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.InsuranceClaimRejectReason,
      );

    modalRef.componentInstance.title = 'INSURANCE_CLAIM_LBL_REJECT_TITLE';
    modalRef.componentInstance.cancelButton = true;
    modalRef.componentInstance.buttons = [
      <ActionButton>{
        actionName: 'insuranceClaimRejectReason',
      },
    ];

    modalRef.componentInstance.inputParams = {
      insuranceClaimId: this.insuranceClaimId,
      source: SourceEnum.Modal,
      rejectReasonMaxLength:
        this.configurationService.getRejectReasonMaxLength(),
    };
  }
}
